import { FC, ReactNode } from "react";
import cn from "classnames";

export type HoverParallaxImageProps = {
  image?: ReactNode;
  backgroundImage?: ReactNode;
  foregroundImage?: ReactNode;
  imageBottomAnimation?: ReactNode;
};

const ANIMATION_TARGET_CLASSNAMES = [
  "group-has-[.animation-trigger-1:hover]:-translate-x-3 group-has-[.animation-trigger-1:hover]:-translate-y-3",
  "group-has-[.animation-trigger-2:hover]:-translate-y-5",
  "group-has-[.animation-trigger-3:hover]:translate-x-3 group-has-[.animation-trigger-3:hover]:-translate-y-3",
  "group-has-[.animation-trigger-4:hover]:-translate-x-5",
  "group-has-[.animation-trigger-6:hover]:translate-x-5",
  "group-has-[.animation-trigger-7:hover]:-translate-x-3 group-has-[.animation-trigger-7:hover]:translate-y-3",
  "group-has-[.animation-trigger-8:hover]:translate-y-5",
  "group-has-[.animation-trigger-9:hover]:translate-x-3 group-has-[.animation-trigger-9:hover]:translate-y-3",
];

const HoverParallaxImage: FC<HoverParallaxImageProps> = ({
  image,
  foregroundImage,
  backgroundImage,
  imageBottomAnimation,
}) => {
  return (
    <div className="group relative">
      <div className="pointer-events-none absolute inset-0 z-20 hidden lg:block">
        <div className="relative h-full">
          <div className="absolute -top-[6.6875rem] -left-[4.1875rem] grid size-80 grid-cols-3 grid-rows-3">
            <div className="animation-trigger-1 pointer-events-auto" />
            <div className="animation-trigger-2 pointer-events-auto" />
            <div className="animation-trigger-3 pointer-events-auto" />
            <div className="animation-trigger-4 pointer-events-auto" />
            <div className="animation-trigger-5 pointer-events-auto" />
            <div className="animation-trigger-6 pointer-events-auto" />
            <div className="animation-trigger-7 pointer-events-auto" />
            <div className="animation-trigger-8 pointer-events-auto" />
            <div className="animation-trigger-9 pointer-events-auto" />
          </div>
        </div>
      </div>
      <div className="pointer-events-none relative inset-0 z-10 h-full sm:absolute">
        <div className="relative size-full">
          <div className="relative top-[0.0625rem] right-0 left-[1.0625rem] size-full sm:absolute sm:-top-[1.875rem] sm:right-auto sm:-left-[9rem] md:-top-[10.0625rem] md:right-0 lg:-top-[10.6875rem]">
            {image && (
              <div className="relative top-0 right-0 left-0 h-[23.25rem] w-[27.375rem] sm:absolute sm:inset-x-0 sm:h-[46.8125rem] sm:w-[56.9375rem] md:-top-[1.25rem] md:-right-[2.5rem] lg:top-0">
                {image}
              </div>
            )}
            {backgroundImage && (
              <div className="absolute top-[1.5rem] right-0 left-[1.375rem] -z-10 h-[22.1875rem] w-[27.125rem] sm:absolute sm:top-[3.125rem] sm:-right-0 sm:left-[2.875rem] sm:h-[46.1875rem] sm:w-[56.4375rem] md:top-[1.875rem] md:-right-48 lg:top-[3.125rem]">
                {backgroundImage}
              </div>
            )}
            {foregroundImage && (
              <div
                className={cn(
                  "absolute top-[3.0625rem] left-[4.375rem] z-10 h-[6.375rem] w-[7rem] transition-transform duration-500 ease-in-out sm:top-[6.4375rem] sm:right-auto sm:left-[9.125rem] sm:h-[13.25rem] sm:w-[14.5625rem] sm:translate-x-0 md:top-[5.1875rem] md:right-[23.25rem] lg:top-[6.4375rem]",
                  ANIMATION_TARGET_CLASSNAMES,
                )}
              >
                {foregroundImage}
              </div>
            )}
            {imageBottomAnimation && (
              <div className="absolute top-[10.0625rem] -left-[1.4375rem] -z-20 h-[13.125rem] w-[22.75rem] overflow-y-hidden sm:top-[30.375rem] sm:-left-[6.6875rem] sm:h-[10.375rem] md:top-[28.6875rem] md:-left-[10.875rem] md:h-[13.1875rem] lg:top-[29.5625rem]">
                {imageBottomAnimation}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoverParallaxImage;
